<template>
  <div class="taxdisk">
    <van-swipe class="my-swipe" indicator-color="white" @change="onSwipeChange" ref="swipeRef">
      <van-swipe-item v-for="(v, i) in deviceList" :key="i">
        <div class="inner">
          <div class="backimg"></div>
          <div class="content">
            <DeviceDisk
              :toolsType="v.deviceType"
              :deviceNo="v.deviceNo"
              :deviceOnlineStatus="deviceOnlineStatus"
            />
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div>
      <FormList
        :list="formList"
        :data="formData"
        :onChange="onInputChange"
        :onFocus="onFocus"
      >
        <div slot="revenueCode" >
          <van-button type="info" @click="handleClick('intelligentCode')">智能赋码</van-button>
        </div>
      </FormList>
    </div>
    <div class="invoice-count" v-if="this.formData.deviceNo === this.currentDeviceNo">
      <header>发票库存</header>
      <section v-if="blankInvoiceList.length">
        <div class="grid title">
          <div>发票类型</div>
          <div>剩余张数</div>
        </div>
        <div class="grid" v-for="(v, i) in blankInvoiceList" :key="i">
          <div>{{v.invoiceTypeStr}}</div>
          <div>{{v.quantity}}</div>
        </div>
      </section>
      <section v-else>
        <van-empty description="暂无数据" />
      </section>
    </div>
    <div class="button" @click="handleClick('syncInvoice')" v-if="this.formData.deviceNo === this.currentDeviceNo">
      同步
    </div>
  </div>
</template>

<script>
import DeviceDisk from '@components/DeviceDisk'
import FormList from '@components/FormList'
import { deepCopy, renderTextWithConfig } from '@utils/basicUtil'
import { invoiceRequest } from '@services'
import { TOOLS_TYPE } from '@assets/config'
import {
  Swipe,
  SwipeItem,
  Empty,
  Skeleton
} from 'vant'
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Empty.name]: Empty,
    [Skeleton.name]: Skeleton,
    DeviceDisk,
    FormList
  },
  props: {
    deviceList: {
      type: Array,
      default: () => []
    },
    blankInvoiceList: {
      type: Array,
      default: () => []
    },
    currentCompany: {
      type: Object,
      default: () => {}
    },
    changeDevice: {
      type: Function,
      default: () => {}
    },
    syncBlankInvoiceAsync: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      formData: {},
      deviceOnlineStatus: false
    }
  },
  computed: {
    formList () {
      return [
        {
          type: 'info',
          field: 'deviceType',
          label: '设备类型',
          render: (text) => renderTextWithConfig(text, TOOLS_TYPE)
        },
        {
          type: 'info',
          field: 'deviceNo',
          label: '盘号/终端号'
        },
        {
          type: 'info',
          field: 'isThrVersion',
          label: '是否金税3.0',
          render: (text) => text === 1 ? '是' : '否'
        },
        {
          type: 'info',
          field: 'applicationRange',
          label: '应用范围',
          render: () => '全员可用'
        },
        {
          type: 'info',
          field: 'status',
          label: '设备状态',
          render: (text) => this.formData.deviceNo === this.currentDeviceNo ? '正在使用' : '点击切换'
        }
      ]
    },
    currentDeviceNo () {
      if (this.currentCompany && this.currentCompany.currentDevice && this.currentCompany.currentDevice.deviceNo) {
        return this.currentCompany.currentDevice.deviceNo
      }
      return ''
    }
  },
  watch: {
    deviceList (value) {
      this.formData = deepCopy(value[0])
      this.setInitDisk()
    }
  },
  created () {},
  mounted () {
    this.formData = deepCopy(this.deviceList[0]) || {}
    this.queryOnLine()
  },
  activated () {},
  updated () {},
  methods: {
    setInitDisk () {
      let currentDeviceNo = ''
      if (this.currentCompany && this.currentCompany.currentDevice && this.currentCompany.currentDevice.deviceNo) {
        currentDeviceNo = this.currentCompany.currentDevice.deviceNo
      }
      const index = this.deviceList.findIndex(v => v.deviceNo === currentDeviceNo)
      this.$refs.swipeRef.swipeTo(index)
    },
    onSwipeChange (index) {
      this.formData = deepCopy(this.deviceList[index])
      this.queryOnLine()
      console.log(this.formData)
    },
    handleClick (type) {
      if (type === 'syncInvoice') {
        this.syncBlankInvoiceAsync()
      }
    },
    onInputChange ({ e, field }) {
      console.log(e, field)
    },
    onFocus ({ e, field }) {
      if (field === 'status') {
        this.changeDevice(this.formData.id)
      }
    },
    async queryOnLine () {
      const result = await invoiceRequest.blank.queryOnLine({})
      if (result.success) {
        this.deviceOnlineStatus = result.result
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
